<template>
    <v-card :id="id" color="grey lighten-2 fill-height">
        <psi-card-heading
            :headingTitle="title"
            :icon="icon"
            :heading-color="headingColor"
        ></psi-card-heading>
        <v-card-text class="d-flex mt-2 fill-height">
            <v-avatar size="100" class="mr-2">
                <v-img
                    :src="program.icon_filepath"
                    max-height="100"
                    max-width="100"
                />
            </v-avatar>
            <div>
                <h3 class="mb-2">
                    {{ program.name }}
                </h3>
                <div class="d-flex">
                    <v-icon class="mr-2">mdi-calendar</v-icon>
                    <h4>
                        {{ session.name }}<br />
                        <span class="font-weight-regular text-body-2"
                            >{{ $dateFormat(session.start_date) }} -
                            {{ $dateFormat(session.end_date) }}
                        </span>
                    </h4>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    name: "student-program",
    components: {},
    props: {
        programs: {
            type: Array,
            required: true,
        },
        sessions: {
            type: Array,
            required: true,
        },
        title: {
            type: String,
            required: false,
            default: "Program",
        },
        icon: {
            type: String,
            required: false,
            default: "mdi-folder-home",
        },
        headingColor: {
            type: String,
            required: false,
            default: "primary",
        },
        id: {
            type: String,
            required: false,
            default: "program-session",
        },
    },
    data() {
        return {};
    },
    computed: {
        program() {
            return this.programs.length > 0 ? this.programs[0] : {};
        },
        session() {
            return this.sessions.length > 0
                ? this.sessions.find((session) => session.isCurrent) ||
                      this.sessions[0]
                : {};
        },
    },
};
</script>

<style scoped>
</style>